import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ReactJson from 'react-json-view';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
	textField: {
		fontWeight: 'bold'
	},
	codeWrapper: {
		borderRadius: 5,
		backgroundColor: theme.palette.background.default
	},
	code: {
		margin: 10,
		display: 'inline-block',
		wordBreak: 'break-word'
	},
	fullWidth: {
		width: '100%'
	}
});

const Code = withStyles(styles)(({ classes, input, fullWidth }) => (
	<div className={classnames(classes.codeWrapper, fullWidth ? classes.fullWidth : null)}>
		<code className={classes.code}>{input}</code>
	</div>
));

/**
 * Renders Json Objects and Json Strings in an interactive JSON component.
 * If the input-data cannot be rendered as JSON, it returns plain Text.
 *
 * @param {*} param0
 */
class JsonTextField extends Component {
	checkInputAndDeriveState() {
		const { record, source } = this.props;
		const input = get(record, source);
		let json = null;
		if (typeof input === 'object') {
			json = input;
		} else if (typeof input === 'string') {
			try {
				json = JSON.parse(input);
			} catch (_) {}
		}
		return {
			record,
			source,
			input,
			json
		};
	}

	constructor(props) {
		super(props);
		this.state = this.checkInputAndDeriveState();
	}

	componentDidUpdate() {
		const { record, source } = this.props;
		const input = get(record, source);
		if (input !== this.state.input) {
			this.setState(this.checkInputAndDeriveState());
		}
	}

	render() {
		const { fullWidth, collapsed } = this.props;
		const { json, input } = this.state;
		if (json) {
			return (
				<ReactJson
					iconStyle="square"
					collapseStringsAfterLength="20"
					onEdit={false}
					onDelete={false}
					onAdd={false}
					collapsed={collapsed}
					src={json}
				/>
			);
		} else {
			return <Code input={input} fullWidth={fullWidth} />;
		}
	}
}

JsonTextField.propTypes = {
	label: PropTypes.string,
	addLabel: PropTypes.bool,
	record: PropTypes.object,
	source: PropTypes.string.isRequired,
	collapsed: PropTypes.bool,
};

JsonTextField.defaultProps = {
	addLabel: true,
	collapsed: false,
};

export default JsonTextField;
